import { render, staticRenderFns } from "./PostEditImmoObject1310CmiModel.vue?vue&type=template&id=60ee7cfe&"
import script from "./PostEditImmoObject1310CmiModel.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject1310CmiModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports